function normalizeBackendSteps(backendRun = {}, localRun = {}, rawAssets = [], fallbackStatus = "done") {
  const now = new Date().toISOString();
  const backendSteps = Array.isArray(backendRun.steps) ? backendRun.steps : [];
  const localSteps = Array.isArray(localRun.steps) ? localRun.steps : [];
  return backendSteps.length
    ? backendSteps.map((step) => ({
        ...step,
        status: step.status || fallbackStatus,
        at: step.at || now,
      }))
    : localSteps.map((step) => ({
        ...step,
        status: fallbackStatus,
        at: step.at || now,
      }));
}

export function mergeRemoteRun(localRun, backendRun = {}, rawAssets = []) {
  const status = backendRun.status || localRun.status || "running";
  const finishedAt = backendRun.finished_at || (status === "completed" || status === "failed" ? new Date().toISOString() : null);
  const steps = normalizeBackendSteps(backendRun, localRun, rawAssets, status === "completed" ? "done" : "pending");

  return {
    ...localRun,
    id: localRun.id || backendRun.id,
    remote: true,
    status,
    finished_at: finishedAt,
    model: backendRun.model || localRun.model,
    model_name: backendRun.model || localRun.model_name,
    asset_ids: backendRun.asset_ids || rawAssets.map((asset) => asset.id),
    backend_run_id: backendRun.id || localRun.backend_run_id,
    prompt: backendRun.prompt || localRun.prompt,
    title: backendRun.title || localRun.title,
    grounding: backendRun.grounding || localRun.grounding,
    platforms: backendRun.platforms || localRun.platforms,
    skills_used: backendRun.skills_used || localRun.skills_used,
    audience: backendRun.audience || localRun.audience,
    research_mode: backendRun.research_mode || localRun.research_mode,
    started_at: backendRun.started_at || localRun.started_at,
    steps,
  };
}

export function finalizeRemoteRun(localRun, backendRun = {}, rawAssets = []) {
  const now = new Date().toISOString();
  const steps = normalizeBackendSteps(backendRun, localRun, rawAssets, "done");

  return {
    ...localRun,
    status: "completed",
    finished_at: now,
    model: backendRun.model || localRun.model,
    model_name: backendRun.model || localRun.model_name,
    asset_ids: backendRun.asset_ids || rawAssets.map((asset) => asset.id),
    backend_run_id: backendRun.id,
    steps,
  };
}

function stepFromWorkflowEvent(event = {}, now) {
  return {
    id: event.id || event.workflow_phase_id || `step_${Math.random().toString(36).slice(2, 8)}`,
    label: event.label || "Agent phase",
    status: event.status === "error" ? "failed" : event.status || "done",
    at: event.at || now,
    started_at: event.started_at || event.at || now,
    finished_at: event.finished_at || event.at || now,
    duration_ms: event.duration_ms,
    phase: event.phase || "",
    note: event.note || "",
    workflow_phase_id: event.workflow_phase_id || "",
    ui_event: event.ui_event || "",
    failure_code: event.failure_code || "",
    query: event.query || undefined,
    source_count: event.source_count,
    research_focus: event.research_focus || undefined,
    failed_platform: event.failed_platform || undefined,
  };
}

export function finalizeFailedRemoteRun(localRun, error = {}) {
  const now = new Date().toISOString();
  const detail = error?.detail || {};
  const message = detail.message || error?.message || "Live generation failed";
  const workflowEvents = Array.isArray(detail.workflow_events) ? detail.workflow_events : [];
  const steps = workflowEvents.length
    ? workflowEvents.map((event) => stepFromWorkflowEvent(event, now))
    : (localRun.steps || []).map((step) => (
        step.status === "running"
          ? { ...step, status: "failed", error: message, at: now }
          : step
      ));

  return {
    ...localRun,
    remote: true,
    status: "failed",
    error: message,
    failure_code: detail.failure_code || "",
    failed_phase: detail.failed_phase || "",
    finished_at: now,
    asset_ids: [],
    steps,
  };
}
